import type { DocumentViewerPatient } from '../../documents/viewer/types';
import { FacesheetDocumentBody } from '../FacesheetDocumentBody';
import { FacesheetQuestionRow } from '../FacesheetQuestionRow';
import { FacesheetReferencesSidebar } from '../FacesheetReferencesSidebar';
import { ReferenceDetailSkeleton } from '../ReferenceDetailSkeleton';
import type {
  AnchorScrollTarget,
  FacesheetSourceContent,
  ReferenceContentState,
} from '../types';

interface ReferenceViewerContentProps {
  reference: ReferenceContentState;
  source?: FacesheetSourceContent;
  patient?: DocumentViewerPatient;
  targetPage?: number;
  anchorScrollTarget?: AnchorScrollTarget;
  anchorScrollKey?: number;
  onPageChange?: (page: number) => void;
  onSelectReference: (referenceId: string) => void;
  isDocumentLoading?: boolean;
}

export const ReferenceViewerContent = ({
  reference,
  source,
  patient,
  targetPage,
  anchorScrollTarget,
  anchorScrollKey,
  onPageChange,
  onSelectReference,
  isDocumentLoading = false,
}: ReferenceViewerContentProps) => {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <FacesheetQuestionRow criteriaRow={reference.criteriaRow} />
      <div className="flex min-h-0 flex-1 overflow-hidden">
        {isDocumentLoading || !source ? (
          <ReferenceDetailSkeleton />
        ) : (
          <FacesheetDocumentBody
            source={source}
            patient={patient}
            targetPage={targetPage}
            onPageChange={onPageChange}
            anchorScrollTarget={anchorScrollTarget}
            anchorScrollKey={anchorScrollKey}
          />
        )}
        <FacesheetReferencesSidebar
          references={reference.criteriaRow.references}
          activeReferenceId={reference.activeReferenceId}
          onSelectReference={onSelectReference}
        />
      </div>
    </div>
  );
};
